import React from 'react';
import { EditListingIcon } from '@components/IRIS/common/irisIcons';
import { AppsSVG, TemplatesIcon } from '@components/drive/driveIcons';
import {
  AICareerFinancialIcon,
  AICareerPathSVG,
  AIGeneratedCLIcon,
  LinkedInNew,
  QuestionGeneratorSVG,
} from '@components/userDocuments/editDocument/editJournal/toolset/assets/icons';

const commonRightList = () => {
  return [
    {
      type: 'text',
      text: 'Features',
      className: 'resumeList',
      dropdownName: 'resumeDropdown',
      childrenList: [
        {
          type: 'url',
          text: 'Resume Builder',
          url: '/resume-builder',
          description: 'Create ATS + recruiter friendly resumes quickly.',
          icon: <EditListingIcon fill="#333d47" width="20" height="20" />,
        },
        // {
        //   type: 'url',
        //   text: 'AI Realistic Interview Preparation',
        //   url: '/ai-mock-interview',
        //   description: 'Practice realistic interview questions with AI.',
        //   icon: <VideoIcon fill="#333d47" width="20" height="20" />,
        // },
        {
          type: 'url',
          text: 'AI Resume Review',
          url: '/resume-review',
          description: 'Get instant AI-powered resume feedback.',
          icon: <AppsSVG fill="#333d47" width="20" height="20" />,
        },
        {
          type: 'url',
          text: 'Cover Letter Builder',
          url: '/cover-letter-builder',
          description: 'Craft persuasive cover letters effortlessly.',
          icon: <TemplatesIcon fill="#333d47" width="20" height="20" />,
        },
        {
          type: 'url',
          text: 'AI Cover Letter Review',
          url: '/cover-letter-review',
          description: 'Get actionable AI suggestions on your letter.',
          icon: <AppsSVG fill="#333d47" width="20" height="20" />,
        },
        {
          type: 'url',
          text: 'AI Generated Cover Letter',
          url: '/ai-generated-cover-letter',
          description: 'Generate tailored cover letters using AI.',
          icon: <AIGeneratedCLIcon fill="#333d47" width="20" height="20" />,
        },
        {
          type: 'url',
          text: 'AI Interview Question Generator',
          url: '/ai-interview-question-generator',
          description: 'Generate interview questions from your resume.',
          icon: <QuestionGeneratorSVG fill="#333d47" width="20" height="20" />,
        },
        {
          type: 'url',
          text: 'AI LinkedIn Builder',
          url: '/linkedIn-builder',
          description: 'Build a strong LinkedIn profile with AI help.',
          icon: <LinkedInNew fill="#333d47" width="20" height="20" />,
        },
        {
          type: 'url',
          text: 'AI Career Path Guidance',
          url: '/ai-career-path-guidance',
          description: 'Find your best-fit career path using AI insights.',
          icon: <AICareerPathSVG fill="#333d47" width="20" height="20" />,
        },
        {
          type: 'url',
          text: 'AI Career Financial Analysis',
          url: '/ai-career-financial-analysis',
          description: 'Understand the financial outlook of your career.',
          icon: <AICareerFinancialIcon width="20" height="20" />,
        },
      ],
    },
    { type: 'url', url: '/blogs', text: 'Blogs', className: 'blogGallery' },
    {
      type: 'url',
      text: 'Higher Education',
      url: '/higher-education',
      className: 'higherEducation',
    },
    {
      type: 'url',
      text: 'Veterans',
      url: '/veterans',
      className: 'veterans',
    },
    { type: 'url', url: '/pricing', text: 'Pricing', className: 'pricing' },
  ];
  // return [
  //   { type: 'url', url: '/blogs', text: 'Blogs', className: 'blogGallery' },
  //   {
  //     type: 'text',
  //     text: 'Resume',
  //     className: 'resumeList',
  //     dropdownName: 'resumeDropdown',
  //     childrenList: [
  //       ...resumeItem,
  //       {
  //         type: 'url',
  //         text: 'Features & Benefits',
  //         url: '/#features-and-benefits',
  //         className: 'featuresBenefits',
  //         icon: <Features fill="#333d47" width="20" height="20" />,
  //       },
  //       {
  //         type: 'url',
  //         text: 'How To Write A Resume',
  //         url: '/blogs/beginners-guide-for-writing-a-stunning-resume-in-2021-(updated)',
  //         className: 'writeResume',
  //         icon: <Article fill="#333d47" width="20" height="20" />,
  //       },
  //     ],
  //   },
  //   {
  //     type: 'text',
  //     text: 'Cover Letter',
  //     className: 'coverLetterList',
  //     dropdownName: 'resumeDropdown',
  //     childrenList: [
  //       ...coverLetterItem,
  //       {
  //         type: 'url',
  //         text: 'How To Write A Cover Letter',
  //         url: '/blogs/how-to-write-a-cover-letter-with-no-experience',
  //         className: 'writeResume',
  //         icon: <Article fill="#333d47" width="20" height="20" />,
  //       },
  //     ],
  //   },
  //   {
  //     type: 'text',
  //     text: 'Services',
  //     className: 'coverLetterList',
  //     dropdownName: 'resumeDropdown',
  //     childrenList: [higherEducation],
  //   },
  //   { type: 'url', url: '/pricing', text: 'Pricing', className: 'pricing' },
  // ];
};

export default {
  loggedInRightList: [
    {
      type: 'url',
      url: `/drive/apps`,
      text: 'Home',
      className: 'myDrive',
    },

    {
      type: 'url',
      url: `/learn`,
      text: 'Learn',
      className: 'learning',
    },

    {
      type: 'externalURL',
      url: `https://youtu.be/poi9l_2LMsk`,
      text: 'Tutorial',
      className: 'tutorial',
    },
    {
      type: 'url',
      url: '/services',
      text: 'Review Services',
      ariaLabel: 'Review service button',
      className: 'services',
      beta: false,
    },
    {
      type: 'externalURL',
      url: `https://wisedoc.net/blogs?appType=CRA&path=/blogs`, // Here we are hard coding this URL temporarily because config is associated with multiple places.
      text: 'Blogs',
      className: 'blogs-gallery',
    },
    { type: 'url', url: '/pricing', text: 'Pricing', className: 'pricing' },
  ],
  logoutRightList: [...commonRightList()],
};
